<template>
  <el-select
    ref="select"
    :class="[multiple ? 'ad-multi-select' : '']"
    :value="value"
    placeholder="请选择"
    filterable
    remote
    :clearable="clearable === undefined"
    :multiple="multiple"
    :remote-method="remoteMethod"
    reserve-keyword
    @input="handleInputValue"
    :no-data-text="noDataText || '暂无数据'"
    :loading="loading"
    :loading-text="loadingText"
    :disabled="disabled"
    @focus="handleInputFocus"
    @change="handleChange"
  >
    <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>
<script>
import { debounce } from 'lodash'

export default {
  props: [
    'filter',
    'optionsMap',
    'serviceName',
    'value',
    'primaryKey',
    'disabled',
    'isNoLableClean',
    'extendField',
    'multiple',
    'noDataText',
    'echoData',
    'clearable'
  ],
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      options: [],
      total: 0,
      inputValue: this.value,
      pageObj: {
        pageNo: 1,
        pageSize: 10,
        tvbOperator: 'like'
      }
    }
  },
  mounted() {
    const filter = { ...this.pageObj, ...this.filter, ...this.primaryKey }
    this.getList(filter)
    if (this.multiple && this.value) {
      this.options = [...this.options, ...this.echoData]
    }
    const SELECTWRAP_DOM = this.$el.querySelector(
      '.el-select-dropdown .el-select-dropdown__wrap'
    )
    SELECTWRAP_DOM.addEventListener('scroll', debounce(this.handleScroll, 500))
  },
  methods: {
    handleScroll(event) {
      const el = event.target
      const isReachBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 5
      if (isReachBottom && this.getDataStatus() === 'HAS_MORE') {
        this.loadMore()
      }
    },
    loadMore() {
      this.showLoading()
      this.pageObj.pageNo++
      const filter = { ...this.pageObj, ...this.filter }
      this.getList(filter).then(() => {
        const status = this.getDataStatus()
        if (status === 'NO_MORE') {
          this.showNoMore()
        }
        if (status === 'HAS_MORE') {
          this.removeTips()
        }
      })
    },
    getDataStatus() {
      return this.options.length < this.total ? 'HAS_MORE' : 'NO_MORE'
    },
    showNoMore() {
      this.$nextTick(() => {
        this.appendTips()
        document.getElementById('appendId').innerText = '没有数据了'
      })
    },
    showLoading() {
      this.$nextTick(() => {
        this.appendTips()
        document.getElementById('appendId').innerText = '加载中'
      })
    },
    appendTips() {
      if (!document.getElementById('appendId')) {
        const appendHTML = document.createElement('div')
        appendHTML.id = 'appendId'
        appendHTML.style.textAlign = 'center'
        appendHTML.style.color = '#999'
        appendHTML.style.fontSize = '14px'
        document
          .querySelector('body>.el-select-dropdown.el-popper .el-scrollbar__wrap')
          .appendChild(appendHTML)
      }
    },
    removeTips() {
      if (document.getElementById('appendId')) {
        document.getElementById('appendId').remove()
      }
    },
    getList(formData) {
      this.removeTips()
      // 这里是接口请求数据, 带分页条件
      return this.$service[this.serviceName](formData).then((data) => {
        const labelMap = this.optionsMap.label.split('.')
        const list = data ? (data.rows ? data.rows : data.list) : []
        const optionValues = this.options.map((item) => item.value)
        const result = (list || [])
          .filter((item) => {
            return !optionValues.includes(item[this.optionsMap.key])
          })
          .map((item) => {
            const resItem = {
              label:
                labelMap.length > 1 ? item[labelMap[0]][labelMap[1]] : item[labelMap[0]],
              value: item[this.optionsMap.key]
            }
            this.extendField && Object.assign(resItem, item)
            return resItem
          })
        this.options = [...this.options, ...result]
        this.total = data.total
        if (this.options.length === 0) {
          this.loading = true
          this.loadingText = this.noDataText || '暂无数据'
        } else {
          this.loading = false
          this.loadingText = '加载中'
        }
      })
    },
    remoteMethod(query) {
      this.pageObj.pageSize = 10
      this.pageObj.pageNo = 1
      this.handleSearchParams(query, this.filter)
      if (query !== '') {
        setTimeout(() => {
          this.loading = true
          const filter = { ...this.pageObj, ...this.filter }
          this.options = []
          this.getList(filter)
        }, 200)
      } else {
        setTimeout(() => {
          this.options = []
          const filter = { ...this.pageObj, ...this.filter }
          this.getList(filter)
          if (document.getElementById('appendId')) {
            document.getElementById('appendId').remove()
          }
        }, 200)
      }
    },
    handleInputValue(val) {
      if (typeof val === 'string') {
        this.pageObj.pageNo = 1
        this.handleSearchParams(val, this.filter)
        const filter = { ...this.pageObj, ...this.filter }
        this.options = []
        this.getList(filter)
      }
      this.$emit('input', val)
    },
    handleSearchParams(query, obj) {
      for (let i in obj) {
        if (typeof obj[i] === 'object') {
          this.handleSearchParams(query, obj[i])
        } else {
          obj[i] = (query !== undefined && query !== '') ? query : undefined // 这里只能查询第一个参数的值
          return true
        }
      }
    },
    handleCleanLabel(value) {
      if (!this.options.some((item) => item.value === value) && this.isNoLableClean) {
        this.$emit('input', '')
      }
    },
    handleInputFocus() {
      this.options = []
      this.loading = true
      this.loadingText = '加载中'
      this.remoteMethod('')
    },
    handleChange(val) {
      const order = this.options.filter((item) => {
        return this.multiple ? val.indexOf(item.value) > -1 : item.value === val
      })
      this.$emit('selected', order)
      this.$nextTick(() => {
        this.$refs.select && this.$refs.select.blur()
      })
    }
  },
  created() {},
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true)
  }
}
</script>

<style lang="stylus" scoped>
.ad-multi-select
  width 100%
  line-height normal
  >>>.el-select__tags
    margin-left 3px
  >>>.el-tag.el-tag--info
    background-color #fff3e6
    border-color #fff3e6
    color #ff8b00
  >>>.el-tag.el-tag--info .el-tag__close
    color #ff8b00
    background none
</style>
